import { useState } from 'react';
import { toast } from 'react-toastify';
import { useConfig } from '../Providers/ConfigProvider';
import { GetDocumentPdf, GetBalancePdf } from '../Services/InvoiceService';
import { useAuth } from '../Providers/AuthProvider';

const useDownloadFinanceDocuments = () => {
    const [isLoading, setIsLoading] = useState(false)
    const [isLoadingBalancePdf, setIsLoadingBalancePdf] = useState(false)
    const { api } = useConfig()
    const { authState } = useAuth()

    const downloadFinanceDocument = async (docNo, docDate, siteId) => {
        try {
            setIsLoading(true);

            const response = await GetDocumentPdf(api, docNo, docDate, siteId);

            if (response.data.size === 0) {
                toast.error('Brak pliku do pobrania!');
                throw new Error("Plik jest pusty!");
            }

            // Otwieramy PDF w nowej karcie
            /* const url = window.URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }));
            window.open(url, "_blank"); // Nowa karta */

            //Pobieramy plik PDF
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${docNo}_${docDate}.pdf`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            toast.success('Pomyślnie pobrano plik');
        } catch (error) {
            console.error('Błąd pobierania pliku:', error);
            toast.error('Brak pliku do pobrania!');
        } finally {
            setIsLoading(false);
        }
    };

    const handleGetBalancePdf = async (whId) => {
        try {
            if (authState.user?.isOperator && !authState.selectedCustomerData) {
                toast.warning('Brak wybranego kontrahenta')
                return
            }
            let contractorName = authState.selectedCustomerData ? authState.selectedCustomerData.fullName : authState.user.customerInfo[0].fullName
            let tax = authState.selectedCustomerData ? authState.selectedCustomerData.tax : authState.user.customerInfo[0].nip
            let creatorName = authState.user.firstName + ' ' + authState.user.lastName

            setIsLoadingBalancePdf(true)
            if (whId) {
                await handleDownloadBalancePdf(contractorName, tax, creatorName, whId)
                toast.success('Pomyślnie pobrano plik PDF')
            }
            else {
                let whList = ['0101', '0201']
                for (const id of whList) {
                    await handleDownloadBalancePdf(contractorName, tax, creatorName, id)
                }
                toast.success('Pomyślnie pobrano pliki PDF')
            }
        } catch (error) {
            if (error.response && error.response.status === 404) {
                toast.warning('Brak danych do wygenerowania raportu!')
                return
            }
            console.error('Błąd pobierania pliku:', error)
            toast.error('Nie udało się pobrać pliku!')
        }
        finally {
            setIsLoadingBalancePdf(false)
        }
    }

    const handleDownloadBalancePdf = async (contractorName, tax, creatorName, whId) => {
        const response = await GetBalancePdf(api, contractorName, tax, creatorName, authState.user.isOperator, authState.custId, whId)

        if (response.data.size === 0) {
            toast.error('Brak pliku do pobrania!')
            return
        }
        const whFullName = whId == '0101' ? 'TG-poznań' : 'TG-Warszawa'
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `Saldo kontrahenta ${authState.custId}_${whFullName}.pdf`)
        document.body.appendChild(link)
        link.click()
        link.remove()
    }

    return {
        downloadFinanceDocument,
        handleGetBalancePdf,
        isLoading,
        isLoadingBalancePdf,
    }
}

export default useDownloadFinanceDocuments;
